import React from 'react';
import img from '../../img/istockphoto-1214561965-1024x1024.jpg'
import Calender from './Calender';
const AppointementHeader = ({date,setDate}) => {
    return (
        <div className='container text-white'>
           <div className="row text-white">
               <div 
                data-aos="zoom-in-right"
                  data-aos-easing="linear"
                  data-aos-duration="1500"
               className="col-md-6 text-white">
                   <Calender date={date} setDate={setDate}></Calender>
               </div>
               <div
                 data-aos="zoom-in-right"
                  data-aos-easing="linear"
                  data-aos-duration="1500"
               className="col-md-6">
                    <img src={img} className='img-fluid ' alt="" />
               </div>
           </div>
        </div>
    );
};

export default AppointementHeader;